import { Component, Input, OnInit } from "@angular/core";
import { DialogContentBase, DialogRef } from "@progress/kendo-angular-dialog";
import { IApiInvestigationReportStatus, IApiStoredLocation, IApiUser } from "./../../../../shared/modules/graphql/types/types";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { AuthService } from "./../../../../shared/services/authorization/auth.service";
import { IApiDocument } from "src/app/shared/modules/graphql/types/types";
import { DownloadHelper, InvestigationReportService } from "src/app/shared/services";
import { LoaderService } from "src/app/shared/modules/loader/loader.service";
import { NotificationsService } from "src/app/shared/modules/notifications/notifications.service";
import { investigationReportArchiveCreate, investigationReportsSnapshotsDownload } from "src/app/shared/helpers/auth-config/investigations.config";
import { filter } from "rxjs/operators";
import { getExtensionFromPath } from "src/app/shared/helpers/helper";

@UntilDestroy()
@Component({
  selector: "app-investigation-report-o365-launch",
  templateUrl: "./investigation-report-o365-launch.component.html",
  styleUrls: ["./investigation-report-o365-launch.component.scss"],
})
export class InvestigationReportO365LaunchComponent extends DialogContentBase implements OnInit {
  @Input() public report: IApiDocument;
  public user: IApiUser;
  public cookieUrl = "";
  public storedLocation = IApiStoredLocation;
  private toggled = false;
  public get IInvestigationReportStatus(): typeof IApiInvestigationReportStatus {
    return IApiInvestigationReportStatus;
  }

  public authConfig = {
    investigationReportArchiveCreate,
    investigationReportsSnapshotsDownload
  }

  constructor(
    private auth: AuthService,
    public dialogRef: DialogRef,
    private reportService: InvestigationReportService,
    private loader: LoaderService,
    private notifications: NotificationsService,
    private downloadHelper: DownloadHelper
  ) {
    super(dialogRef);
    this.auth.authenticatedUser
      .pipe(untilDestroyed(this))
      .subscribe((user) => (this.user = user));
  }

  ngOnInit(): void {
    // iFrame URL to pass info into Office o365 addin for cookie
    this.cookieUrl = `https://d2urwrrqk4nn6k.cloudfront.net/cookiepass.html?docId=${this.report?.id}&investId=${this.report?.Investigation?.id}&nefcoNum=${this.report?.Investigation?.nefcoNumber}`;
  }

  public launchReport() {
    window.open(this.report.uri);
    this.dialogRef.close(true);
  }

  toggleLocation() {
    const isArchive = this.report.storedLocation === IApiStoredLocation.OneDrive;
    this.notifications.kendoConfirm(`Are you sure you want to ${isArchive ? 'archive' : 'restore'} this report?`).pipe(
      filter(result => !!result),
    ).subscribe(() => {
      this.loader.show$(
        this.reportService.toggleDocumentLocation(this.report.id).pipe(
          this.notifications.snackbarPipe(`Report ${isArchive ? 'archived' : 'restored'} Successfully`),
          this.notifications.snackbarErrorPipe(),
        )
      ).subscribe(res => {
        this.report = res;
        this.toggled = true;
      })
    });

  }

  public downloadExternal() {
    if (this.report?.s3Uri) {
      const name = this.report?.s3Uri?.split('/').pop();
      this.downloadHelper.externalDownload(this.report?.s3Uri, name);
    }
  }

  public close() {
    this.dialogRef.close(this.toggled)
  }
}
